import { LOGOS } from "@/data/content";

export const Marquee = () => {
  const items = [...LOGOS, ...LOGOS];
  return (
    <section
      id="marquee"
      data-testid="marquee"
      className="py-8 md:py-10 bg-white border-y-4 border-obsidian overflow-hidden"
    >
      <div className="flex w-max items-center animate-marquee whitespace-nowrap will-change-transform">
        {items.map((logo, i) => (
          <div key={i} className="flex items-center justify-center px-8 md:px-12 shrink-0">
            <img
              src={logo.src}
              alt={logo.name}
              className="w-auto object-contain mix-blend-multiply"
              style={{ height: `${(logo.scale || 1) * 48}px` }}
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </section>
  );
};
